
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getAccounts, getMarketsPrematchLive } from '../../../selectors/common';
import { getPrematchMarkets } from '../../../selectors/marketSettings';
import RoleModal from '../../../components/MenuItems/Admin/RoleModal';
import AccountSelection from './AccountSelection';
import PrematchList from './PrematchList';
import { aGetPrematchMarketsByAccount, aSavePrematchMarketsByAccount } from '../../../reducers';

const mapToProps = (state) => ({
  accounts: getAccounts(state),
  markets: getMarketsPrematchLive(state),
  prematchMarkets: getPrematchMarkets(state),
});
const actionsToProps = (dispatch) => ({
  getPrematchMarketsRequest: (payload) => dispatch(aGetPrematchMarketsByAccount(payload)),
  savePrematchMarkets: (payload) => dispatch(aSavePrematchMarketsByAccount(payload)),
});

const PrematchMarket = ({
  accounts, markets,
  prematchMarkets,
  getPrematchMarketsRequest,
  savePrematchMarkets,
}) => {
  const [selectedAccount, setSelectedAccount] = useState('');
  const [isMarketModalOpen, setIsMarketModalOpen] = useState(false);

  useEffect(() => {
    if (selectedAccount) getPrematchMarketsRequest({ roleId: selectedAccount });
  }, [selectedAccount, getPrematchMarketsRequest]);

  const toggleMarketModal = () => {
    setIsMarketModalOpen((prevIsMarketOpen) => !prevIsMarketOpen);
  };

  return (
    <>
      <AccountSelection
        selectedAccount={selectedAccount}
        setSelectedAccount={setSelectedAccount}
        accounts={accounts}
      />
      <div className="content__wrapper-info m-t-15">*Markets for selected account will be displayed in the table(s) below</div>
      <div className="action-btn m-t-15">
        <button
          className="btn btn-primary"
          id="prematchBtn"
          disabled={!selectedAccount}
          type="button"
          onClick={toggleMarketModal}
        >
          Edit
        </button>
      </div>

      <div className="table-wrapper m-t-30">
        {selectedAccount && (
          <PrematchList
            prematchMarkets={prematchMarkets}
          />
        )}

        {isMarketModalOpen ? (
          <div className="modal modal--open">
            <RoleModal
              rolePermissions={prematchMarkets}
              selectedRoleId={selectedAccount}
              permissions={markets}
              getRolePermissions={getPrematchMarketsRequest}
              closeRoleModal={toggleMarketModal}
              isEditingRole
              saveEditRole={savePrematchMarkets}
              role={{ roleId: selectedAccount }}
              assignedLabel="Markets"
              title="Prematch Markets"
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default connect(mapToProps, actionsToProps)(PrematchMarket);
